

{
  "familyId": "MET-MEETK-CIRKEL-DEEL",
  "questions": [
    {
      "id": "MET-MEETK-CIRKEL-DEEL-001",
      "familyId": "MET-MEETK-CIRKEL-DEEL",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_cirkelsector",
      "questionType": "multiple_choice",
      "question": "Een leerling beweert: \"Een sector van 90° is ⅓ van de cirkel, want 90 is een derde van 270.\" Wat klopt er niet?",
      "options": ["De leerling deelt door 270 in plaats van door 360", "De leerling had door 180 moeten delen", "90° is altijd de helft van een cirkel", "De redenering klopt wél"],
      "correctAnswer": 0,
      "stimulusAids": [{"type":"circle","data":{"radius":5,"sectorAngle":90,"highlightSector":true,"label":"Sector van 90°"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Cirkelsector","content":"Een hele cirkel = 360°. Deel = sectorhoek ÷ 360°. Dus 90 ÷ 360 = ¼.","icon":"lightbulb"}}],
      "conceptId": "cirkel_sector_deel",
      "variantIndex": 1,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De leerling maakt een fundamentele denkfout: hij deelt 90 door 270 (de rest van de cirkel) i.p.v. door 360 (de hele cirkel). Een hele cirkel is altijd 360°. De juiste berekening: 90 ÷ 360 = ¼. Controleer: 4 × 90 = 360, dus vier kwart-sectoren vullen precies de cirkel. Onthoud: bij 'deel van het geheel' deel je altijd door het totaal, nooit door de rest.",
        "solutionSteps": [
          "Analyseer: leerling rekent 90 ÷ 270 = ⅓",
          "Identificeer fout: 270° is de rest, 360° is het geheel",
          "Juiste formule: deel = hoek ÷ 360°",
          "Reken: 90 ÷ 360 = ¼",
          "Check: 4 × 90 = 360 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed geanalyseerd! De leerling deelt door 270 (de rest), maar moet delen door 360 (het geheel). 90 ÷ 360 = ¼.",
          "1": "180° is een halve cirkel, niet de hele. Een hele cirkel = 360°. De fout van de leerling is dat hij door 270 deelt; hij moest door 360 delen.",
          "2": "90° is een kwart van de cirkel (360 ÷ 4 = 90), niet de helft. Een halve cirkel = 180°. Onthoud: 90° = ¼.",
          "3": "De redenering klopt niet: 90 ÷ 270 = ⅓, maar dat antwoord is fout omdat de noemer fout is. 90 ÷ 360 = ¼ is het juiste antwoord."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.sector-deel-door-180", "label": "Door 180 i.p.v. 360", "optionIndex": 1 },
          { "id": "met.sector-deel-90-helft", "label": "90° = halve cirkel", "optionIndex": 2 },
          { "id": "met.sector-correct-twijfel", "label": "Foute redenering geaccepteerd", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-CIRKEL-DEEL-002",
      "familyId": "MET-MEETK-CIRKEL-DEEL",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_cirkelsector",
      "questionType": "multiple_choice",
      "question": "Een leerling berekent de oppervlakte van een sector (hoek 60°, straal 6 cm) als: \"(60 ÷ 360) × 2 × π × 6 = 6,28 cm².\" Wat is de fout?",
      "options": ["De leerling deelt door 360 in plaats van door 180", "De leerling vergeet met 2 te vermenigvuldigen", "De leerling gebruikt de omtrekformule (2πr) i.p.v. de oppervlakteformule (πr²)", "Er zit geen fout in"],
      "correctAnswer": 2,
      "stimulusAids": [{"type":"circle","data":{"radius":6,"sectorAngle":60,"highlightSector":true,"label":"Sector 60°, r = 6 cm"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Oppervlakte sector","content":"Sectoroppervlakte = (hoek ÷ 360) × π × r². Hier: ⅙ × π × 36 ≈ 18,85 cm².","icon":"lightbulb"}}],
      "conceptId": "cirkel_sector_oppervlakte",
      "variantIndex": 2,
      "citoDifficulty": 0.62,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "De leerling verwart twee fundamenteel verschillende formules. 2πr is de omtrekformule (lengte, in cm); πr² is de oppervlakteformule (vlak, in cm²). De berekening levert dus eigenlijk een booglengte op, geen oppervlakte. Juist: ⅙ × π × 6² = ⅙ × 113,1 ≈ 18,85 cm². De eenheid verraadt de fout: oppervlakte hoort cm² te zijn, geen cm.",
        "solutionSteps": [
          "Analyseer: 2πr in de berekening — dat is de omtrekformule",
          "Identificeer: omtrek geeft cm (lengte), oppervlakte geeft cm² (vlak)",
          "Juiste formule: sectoropp = (hoek ÷ 360) × π × r²",
          "Reken: ⅙ × π × 36 ≈ 18,85 cm²",
          "Eenheidcheck: cm² (vlak), niet cm (lengte)"
        ],
        "distractorExplanations": {
          "0": "60 ÷ 360 = ⅙ is correct — dat is het juiste deel. De fout zit in welke cirkelformule wordt geschaald: πr² hoort hier, niet 2πr.",
          "1": "Het probleem is niet een ontbrekende factor 2 — er zit zelfs een 2 teveel in (van 2πr). De fundamentele fout is de keuze tussen omtrek- en oppervlakteformule.",
          "2": "Goed geanalyseerd! De leerling gebruikt 2πr (omtrek) i.p.v. πr² (oppervlakte). Juist: ⅙ × π × 36 ≈ 18,85 cm².",
          "3": "Er zit wel degelijk een fout in: 6,28 cm is de booglengte, niet de oppervlakte. De gevraagde sectoroppervlakte is ⅙ × π × 36 ≈ 18,85 cm²."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.sector-deel-360-discutabel", "label": "Twijfelt over ÷ 360", "optionIndex": 0 },
          { "id": "met.sector-factor-twee-twijfel", "label": "Denkt aan ontbrekende ×2", "optionIndex": 1 },
          { "id": "met.sector-correct-twijfel", "label": "Foute formule onopgemerkt", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-CIRKEL-DEEL-003",
      "familyId": "MET-MEETK-CIRKEL-DEEL",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_cirkelsector",
      "questionType": "multiple_choice",
      "question": "Een leerling snijdt een pizza in gelijke punten van 45°. Zijn vriend zegt: \"Dan heb je 6 punten, want 6 × 45 is bijna 360.\" Hoeveel punten passen er precies?",
      "options": ["6 punten, de vriend heeft gelijk", "8 punten, want 360 ÷ 45 = 8 precies", "7 punten, want 7 × 45 ligt het dichtst bij 360", "10 punten, want je rondt naar boven af"],
      "correctAnswer": 1,
      "stimulusAids": [{"type":"circle","data":{"radius":5,"sectorAngle":45,"highlightSector":true,"label":"Pizzapunt 45°"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Aantal sectoren","content":"Aantal = 360° ÷ hoek per sector. Moet exact opgaan — geen halve punt!","icon":"lightbulb"}}],
      "conceptId": "cirkel_sector_aantal",
      "variantIndex": 3,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De vriend rekent fout: 6 × 45 = 270, niet 360. Verschil 90° — dat zijn nog twee hele sectoren. Juist: 360 ÷ 45 = 8 precies. Bij gelijke verdeling moet de deling exact opgaan, anders passen de punten niet rond. Onthoud: controleer altijd door terug te vermenigvuldigen.",
        "solutionSteps": [
          "Vriend zegt: 6 × 45 ≈ 360",
          "Controleer: 6 × 45 = 270 — er ontbreekt 90°",
          "Juiste deling: 360 ÷ 45 = 8",
          "Check: 8 × 45 = 360 ✓"
        ],
        "distractorExplanations": {
          "0": "De vriend heeft ongelijk: 6 × 45 = 270, niet 360. Er ontbreekt 90° — dat zijn nog 2 hele sectoren. Juist: 8 punten.",
          "1": "Goed geanalyseerd! 360 ÷ 45 = 8 precies; 8 × 45 = 360 ✓.",
          "2": "Je rondt af, maar bij verdelen van een cirkel moet de deling exact opgaan: 7 × 45 = 315, daar past nog ruimte tussen. 360 ÷ 45 = 8 exact.",
          "3": "Naar boven afronden mag niet: 10 × 45 = 450, dat is meer dan 360°. Onthoud: pas een waarde alleen aan als de deling exact opgaat — hier dus 8."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.sector-aantal-rekenfout", "label": "Rekenfout 6 × 45", "optionIndex": 0 },
          { "id": "met.sector-aantal-afronden-dichtst", "label": "Afronden naar dichtstbijzijnde", "optionIndex": 2 },
          { "id": "met.sector-aantal-afronden-boven", "label": "Naar boven afronden", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-CIRKEL-DEEL-004",
      "familyId": "MET-MEETK-CIRKEL-DEEL",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_cirkelsector",
      "questionType": "multiple_choice",
      "question": "Een leerling berekent de booglengte (hoek 120°, straal 9 cm) als: \"(120 ÷ 360) × π × 9² = ⅓ × 254,47 = 84,82 cm.\" Wat gaat er fout?",
      "options": ["De leerling deelt door 360 i.p.v. door 180", "De leerling vergeet de straal te kwadrateren", "De berekening is correct", "De leerling gebruikt de oppervlakteformule (πr²) i.p.v. de omtrekformule (2πr)"],
      "correctAnswer": 3,
      "stimulusAids": [{"type":"circle","data":{"radius":9,"sectorAngle":120,"highlightSector":true,"label":"Sector 120°, r = 9 cm"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Booglengte","content":"Booglengte = (hoek ÷ 360) × 2πr = ⅓ × 2 × 3,14 × 9 = 18,84 cm.","icon":"lightbulb"}}],
      "conceptId": "cirkel_sector_booglengte",
      "variantIndex": 4,
      "citoDifficulty": 0.64,
      "citoDiscrimination": 0.66,
      "feedback": {
        "explanationText": "De leerling verwart booglengte met sectoroppervlakte — precies omgekeerd aan de veelgemaakte fout. Booglengte is een stuk omtrek (lengte, cm), dus gebruik 2πr. De leerling pakt πr² (oppervlakte). Juist: ⅓ × 2 × π × 9 = 18,84 cm. De eenheid verraadt het: 84,82 cm² past niet bij booglengte; die hoort in cm.",
        "solutionSteps": [
          "Analyseer: leerling gebruikt πr² — herken oppervlakteformule",
          "Booglengte = deel van omtrek → gebruik 2πr",
          "Reken: ⅓ × 2 × π × 9 = ⅓ × 56,52 = 18,84 cm",
          "Eenheidcheck: cm (lengte), niet cm²"
        ],
        "distractorExplanations": {
          "0": "120 ÷ 360 = ⅓ is correct. De fout zit in de cirkelformule: 2πr (lengte) hoort hier, niet πr² (vlak).",
          "1": "Niet de straal moet anders, maar de formule. De leerling kwadrateert juist (πr²) — voor booglengte gebruik je 2πr (zonder kwadraat).",
          "2": "De berekening is niet correct. 84,82 is in cm² (oppervlakte), maar booglengte hoort in cm te zijn. Juist: ⅓ × 2π × 9 = 18,84 cm.",
          "3": "Goed! De leerling gebruikt πr² i.p.v. 2πr. Juist: ⅓ × 2π × 9 = 18,84 cm. Tip: de eenheid (cm vs. cm²) verraadt de fout."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.sector-deel-360-discutabel", "label": "Twijfelt over ÷ 360", "optionIndex": 0 },
          { "id": "met.sector-factor-twee-twijfel", "label": "Twijfelt over kwadraat", "optionIndex": 1 },
          { "id": "met.sector-correct-twijfel", "label": "Foute berekening goedgekeurd", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "MET-MEETK-CIRKEL-DEEL-005",
      "familyId": "MET-MEETK-CIRKEL-DEEL",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_cirkelsector",
      "questionType": "multiple_choice",
      "question": "Een leerling zegt: \"Een sector van 72° is ¼ van de cirkel, want 72 past 4 keer in 360 met een restje.\" Welk deel is een sector van 72° precies?",
      "options": ["¼, want de leerling rekent goed", "⅕, want 360 ÷ 72 = 5 precies", "⅙, want 72 ÷ 12 = 6", "⅓, want 3 × 72 ≈ 216 ≈ 360"],
      "correctAnswer": 1,
      "stimulusAids": [{"type":"circle","data":{"radius":5,"sectorAngle":72,"highlightSector":true,"label":"Sector van 72°"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Deel van de cirkel","content":"Deel = hoek ÷ 360 = 72 ÷ 360. Vereenvoudig: 72/360 = 1/5. Check: 5 × 72 = 360 ✓.","icon":"lightbulb"}}],
      "conceptId": "cirkel_sector_breuk_analyse",
      "variantIndex": 5,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De leerling schat in plaats van precies te rekenen: hij denkt dat 72 'ongeveer' 4 keer in 360 past. Maar 4 × 72 = 288, dus er ontbreekt 72° — een hele sector. Juist: 360 ÷ 72 = 5 precies, dus 72° = ⅕ van de cirkel. Vereenvoudig: 72/360 = 1/5 (deel teller en noemer door 72). Onthoud: bij breuken van een cirkel moet de deling exact opgaan — geen 'restjes'.",
        "solutionSteps": [
          "Beoordeel bewering: 4 × 72 = 288, niet 360",
          "Verschil: 360 − 288 = 72° — een hele sector ontbreekt",
          "Juiste deling: 360 ÷ 72 = 5",
          "Breuk: 72/360 = 1/5",
          "Check: 5 × 72 = 360 ✓"
        ],
        "distractorExplanations": {
          "0": "De leerling heeft ongelijk: 4 × 72 = 288, niet 360. Er ontbreekt 72° — geen klein restje, maar een hele extra sector. Juist: 1/5.",
          "1": "Goed geanalyseerd! 360 ÷ 72 = 5 exact, dus 72° = 1/5 van de cirkel.",
          "2": "Je hebt 72 door 12 gedeeld, maar de relevante deling is 360 ÷ 72 (hoeveel sectoren passen in de cirkel). 360 ÷ 72 = 5 → 1/5.",
          "3": "Je rondt af op een schatting (3 × 72 ≈ 216, dat is geen 360). Bij delen van een cirkel moet je exact rekenen: 360 ÷ 72 = 5, dus 1/5."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.sector-correct-twijfel", "label": "Schatting i.p.v. rekenen", "optionIndex": 0 },
          { "id": "met.sector-aantal-rekenfout", "label": "Verkeerde deling 72 ÷ 12", "optionIndex": 2 },
          { "id": "met.sector-aantal-afronden-dichtst", "label": "Afronden bij deling", "optionIndex": 3 }
        ]
      }
    }
  ]
}

